import { Make, Model } from '~/types'

export function formattedModel(model: Model) {
    return {
        label: `${model.model} ${model.modelVariant ?? ''}`.trim(),
        value: `${model.model} ${model.modelVariant ?? ''}`
            .toLowerCase()
            .trim(),
    }
}

export function formattedMake(make: Make) {
    return {
        label: make.make,
        value: `${make.id}.${make.make.toLowerCase()}`,
    }
}
